import styles from '../common.scss';
import BundleType from '~/components/BundleType/BundleType';

interface IDogTagSubTitleContentProps {
    item: IBundleEntity;
}

export const DogTagSubTitleContent = (props: IDogTagSubTitleContentProps) => {
    const content = <BundleType item={props.item} />;
    if (!content) {
        return null;
    }

    return (
        <div className={styles.flex}>
            <div className={styles.preBundleTitle}>{content}</div>
        </div>
    );
};
